<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> Emails </h3>
        <small>Cadastro de E-mails para envio de Campanhas</small>
      </div>
    </div>
    <EmailEnvioAdd v-if="showAdd" ref="EmailEnvioAdd" v-on:Back="onBack" />
    <EmailEnvioList v-else ref="EmailEnvioList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import EmailEnvioAdd from './components/add/emailenvioadd.vue'
import EmailEnvioList from './components/list/emailenviolist.vue'

export default {
  name: 'EmailEnvio',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    EmailEnvioAdd,
    EmailEnvioList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.EmailEnvioAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/email/emailenvio.vue